export enum FeedbackStatus {
    Like = 1,
    Dislike = 3
}
